export const typesToIgnore = [
  "friends-requests",
  "teams-requests",
  "challenges-requests",
  "gather-requests",
  "request-to-join-team",
];
